// extracted by mini-css-extract-plugin
module.exports = {"row-input-otp":"index_row-input-otp__Fr6_9","col-input-otp":"index_col-input-otp__LL8R2","wrapper-input":"index_wrapper-input__ZlfXu","input-otp":"index_input-otp__CcF5s"};